import { Lock } from "lucide-react";
import { useGarage } from "@/context/GarageContext";
import { t } from "@/i18n";

export function PlanNotice({ feature, testId = "plan-notice" }) {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-dashed border-slate-300 bg-slate-50 p-5 text-sm text-slate-700" data-testid={testId}>
      <Lock className="mt-0.5 h-4 w-4 shrink-0 text-slate-500" />
      <p><strong>{t("plan.notIncluded", { feature: t(`plan.features.${feature}`) })}</strong><span className="block text-slate-500">{t("plan.notIncludedHint")}</span></p>
    </div>
  );
}

export function PlanGate({ feature, children, managers = false }) {
  const { hasFeature, isManager, access } = useGarage();
  if (!hasFeature(feature)) return <PlanNotice feature={feature} testId={`plan-gate-${feature}`} />;
  if (managers && !isManager && access.role !== "support") {
    return <div className="flex items-start gap-3 rounded-xl border border-dashed border-slate-300 bg-slate-50 p-5 text-sm text-slate-700" data-testid="managers-only-notice"><Lock className="mt-0.5 h-4 w-4 shrink-0 text-slate-500" /><p>{t("plan.managersOnly")}</p></div>;
  }
  return children;
}
